import { Url } from '../shared/Url';
import Post from '../shared/Post';
import PostArchivo from '../shared/PostArchivo';
import { cookieData } from '../funciones/ConsultaUser';

import { requerido, numero, selectRequerido, requeridoFecha, limpiaCamposRepre, email, requeridoFile } from './Validaciones';
import { consultaUser } from "./PefilFunction";

export const guardar = (camps, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];
    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los campos para continuar"
    }];

    let campos = camps.campos[0];


    /* VALIDACIONES DE ADMISION */
    selectRequerido(errores, camps.periodo, "periodoSelect", " - Incompleto - ", "Debes seleccionar el periodo", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    selectRequerido(errores, camps.carrera, "carreraSelect", " - Incompleto - ", "Debes seleccionar la carrera", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (camps.requisitos.length === 0) {
        errores++;
        nameErr.push("Debes elegir al menos un requisito de la lista para consignar")
    }

    /* Validaciones de DATOS PERSONALES */
    requerido(errores, campos.cedula.text, "cedula", "ced", "Cédula de Identidad", "El campo Cédula es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.cedula.text, "cedula", "ced", "El campo Cédula debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre1.text, "nombre1", "nombres", "Nombres", "El campo Primer Nombre es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.apellido1.text, "apellido1", "apellidos", "Apellidos", "El campo Primer Apellido es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /*Validaciones de DATOS DE NACIMIENTO */
    selectRequerido(errores, campos.selectPais, "selectPais", " - Incompleto - ", "Debes seleccionar el País de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    selectRequerido(errores, campos.selectEstado, "selectEstado", " - Incompleto - ", "Debes seleccionar el Estado de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /* selectRequerido(errores, campos.selectCiudad, "selectCiudad", " - Incompleto - ", "Debes seleccionar la Ciudad de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    }); */

    selectRequerido(errores, campos.selectMunicipio, "selectMunicipio", " - Incompleto - ", "Debes seleccionar el Municipio de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    selectRequerido(errores, campos.selectParroquia, "selectParroquia", " - Incompleto - ", "Debes seleccionar la Parroquia de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requeridoFecha(errores, campos.fecha, "Debe seleccionar la Fecha de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /*Validaciones de DATOS DE DIRECCION */
    selectRequerido(errores, campos.selectPaisDir, "selectPaisDir", " - Incompleto - ", "El campo País [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    selectRequerido(errores, campos.selectEstadoDir, "selectEstadoDir", " - Incompleto - ", "El campo Estado [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /* selectRequerido(errores, campos.selectCiudadDir, "selectCiudadDir", " - Incompleto - ", "El campo Ciudad [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    }); */

    selectRequerido(errores, campos.selectMunicipioDir, "selectMunicipioDir", " - Incompleto - ", "El campo Municipio [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    selectRequerido(errores, campos.selectParroquiaDir, "selectParroquiaDir", " - Incompleto - ", "El campo Parroquia [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.calle.text, "calle", "", "", "El campo Calle [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.casa.text, "casa", "", "", "El campo Casa [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /* Validaciones de Teléfono */
    if (campos.tlf1.text !== "") numero(errores, campos.tlf1.text, "tlf1", "telefonos", "El campo Tlf. Habitación debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (campos.tlf2.text !== "") numero(errores, campos.tlf2.text, "tlf2", "telefonos", "El campo Tlf. Celular debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (campos.tlf3.text !== "") numero(errores, campos.tlf3.text, "tlf3", "telefonos", "El campo Tlf. Oficina debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

     /* Validaciones de REPRESENTANTE */
     if(campos.edad < 18) {
        requerido(errores, campos.cedulaRepre.text, "cedulaRepre", "cedRepre", "Cédula de Identidad", "El campo Cédula del Representante es obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        requerido(errores, campos.nombre1Repre.text, "nombre1Repre", "nombresRepre", "Nombres", "El campo Nombre del Representante es obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        requerido(errores, campos.apellido1Repre.text, "apellido1Repre", "apellidosRepre", "Apellidos", "El campo Apellido del Representante es obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        /*Validaciones de DATOS DE DIRECCION */
        selectRequerido(errores, campos.selectPaisRepre, "selectPaisRepre", " - Incompleto - ", "El campo País [Representante] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        selectRequerido(errores, campos.selectEstadoRepre, "selectEstadoRepre", " - Incompleto - ", "El campo Estado [Representante] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        /* selectRequerido(errores, campos.selectCiudadRepre, "selectCiudadRepre", " - Incompleto - ", "El campo Ciudad [Representante] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        }); */

        selectRequerido(errores, campos.selectMunicipioRepre, "selectMunicipioRepre", " - Incompleto - ", "El campo Municipio [Representante] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        selectRequerido(errores, campos.selectParroquiaRepre, "selectParroquiaRepre", " - Incompleto - ", "El campo Parroquia [Representante] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        requerido(errores, campos.calleRepre.text, "calleRepre", "", "", "El campo Calle [Representante] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });
    
        requerido(errores, campos.casaRepre.text, "casaRepre", "", "", "El campo Casa [Representante] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        if(campos.emailRepre.text !== "") email(errores, campos.emailRepre.text, "emailRepre", "", "", "El formato de Email [Representante] es incorrecto", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        /* Validaciones de Teléfono */
        if (campos.tlf1Repre.text !== "") numero(errores, campos.tlf1Repre.text, "tlf1Repre", "telefonosRepre", "El campo Tlf. Habitación [Representante] debe contener solo números", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        if (campos.tlf2Repre.text !== "") numero(errores, campos.tlf2Repre.text, "tlf2Repre", "telefonosRepre", "El campo Tlf. Celular [Representante] debe contener solo números", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        if (campos.tlf3Repre.text !== "") numero(errores, campos.tlf3Repre.text, "tlf3Repre", "telefonosRepre", "El campo Tlf. Oficina [Representante] debe contener solo números", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });
    }else{
        limpiaCamposRepre((resp) => { states.push(resp[0][0]) });
    }

    /* VALIDACIONES TEMPORALES DE  DOCUMENTOS ADJUNTOS */
    /* requeridoFile(errores, camps.file1, "", "", "", "Debes adjuntar copia de la cédula de identidad", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requeridoFile(errores, camps.file2, "", "", "", "Debes adjuntar copia de la partida de nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    }); */

    /* requeridoFile(errores, camps.file3, "", "", "", "Debes adjuntar copia de las notas certificadas", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    }); */
    /* ---------------------------------------------- */

    if (errores === 0){
        consultaUser((usuario) => {
            /* Consultar si la ci o el password ya existen */
            let Content = {
                ci: campos.cedula.text,
                pasaporte: campos.pasaporte.text,
                usuario: usuario
            }

            Post(`${Url}consultDispCiPass`, Content, (resp) => {
                let data = JSON.parse(resp);
                if (data > 0) {
                    let mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los campos en rojo para continuar"
                    }];
                    nameErr.push("La Cédula o el Pasaporte ya están registrados")
                    errores ++;
                    respuesta([states, mensaje, errores, nameErr])
                }else{
                    let mensaje = [{
                        status: "info",
                        mensaje: "Has hecho el proceso de admisión correctamente. Imprime la planilla y dirígete con los documentos seleccionados a administración"
                    }];
                    let Content2 = {
                        campos: camps.campos[0],
                        periodo: camps.periodo,
                        carrera: camps.carrera,
                        requisitos: camps.requisitos,
                        usuario: usuario,
                        nombre: "Ejemplo.pdf"
                    }
                    
                    /* console.log(Content2) */
                    PostArchivo(`${Url}addAdmision`, "", "", Content2, () => {
                        respuesta([states, mensaje, errores, nameErr])
                    });
                }
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const sendFiles = (camps, respuesta) => {
    consultaUser((usuario) => {
        let Content = {
            campos: camps.campos[0],
            usuario: usuario
        }
        
        /* console.log(Content2) */
        PostArchivo(`${Url}sendAdmision`, camps.filePdf, camps.filelamilla, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data);
        });
    });
}

export const DelSolicitud = (respuesta) => {
    consultaUser((usuario) => {
        let Content = {
            usuario: usuario
        }

        Post(`${Url}DelSolicitud`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data);
        });
    })
}

export const  updCupos = (carrera, carrName, cupos, periodo, respuesta) => {
    let errores = 0;
    let mensaje = {
        status: "info",
        mensaje: `Se asignaron correctamente los cupos a ${carrName} para nuevo ingreso`
    };

    let icono = {
        icon: "fa fa-check",
        color: "#32704C" 
    }

    if (carrera === "") {
        mensaje = {
            status: "error",
            mensaje: "Debes seleccionar la carrera a asignar los cupos"
        };
        icono = {
            icon: "fa fa-times",
            color: "#A0555C" 
        }
    }

    if (cupos === "") {
        mensaje = {
            status: "error",
            mensaje: "Debes ingresar una cantidad de cupos para esta carrera"
        };
        icono = {
            icon: "fa fa-times",
            color: "#A0555C" 
        }
    }

    if (periodo === "") {
        mensaje = {
            status: "error",
            mensaje: "Debes seleccionar el periodo para esta carrera"
        };
        icono = {
            icon: "fa fa-times",
            color: "#A0555C" 
        }
    }
    
    numero(errores, cupos, "", "", "Debes seleccionar solo números para los cupos", (resp) => {
        if (resp[1] > 0) {
            mensaje = {
                status: "error",
                mensaje: resp[2]
            };
            icono = {
                icon: "fa fa-times",
                color: "#A0555C" 
            }
        }
    });

    if (mensaje.status === "info") {
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                carrera: carrera,
                cupos: cupos,
                periodo: periodo
            }
    
            Post(`${Url}updCuposNvoIng`, Content, (resp) => {
                respuesta([mensaje, icono])
            });
        });
    }else{
        respuesta([mensaje, icono])
    }
}

export const  consultaCupos = (carrera, periodo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            carrera: carrera,
            periodo: periodo
        }

        Post(`${Url}CuposNvoIng`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const consultApPeriodos = (periodo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            periodo: periodo
        }

        Post(`${Url}searchPeriodosAp`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const updPeriodoAP = (periodo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            periodo: periodo
        }

        Post(`${Url}updPeriodosAp`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const PeriodosDisp = (respuesta) => {
    Post(`${Url}periodosDisp`, "", (resp) => {
        let data = JSON.parse(resp);

        let contenido = [];

        let mes = (num) => {
            let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMPBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]
            return meses[num - 1]
        }

        for (let i in data[0]){
            contenido.push({
                value: data[0][i].id,
                label:`${mes(data[0][i].corte_name)} - ${data[0][i].corte_year}`
            })
        }

        respuesta(contenido)
    });
}

export const CarrerasDisp = (periodo, respuesta) => {
    let Content = {
        periodo: periodo
    }

    Post(`${Url}carerasDispAp`, Content, (resp) => {
        let data = JSON.parse(resp);
        let contenido = [];

        let cupos = (cupos) => {
            let letra = "";
            if (cupos > 1) letra = "S";
            return `[${cupos} CUPO${letra}]`
        }

        for (let i in data[0]){
            contenido.push({
                value: data[0][i].id,
                label: `${data[0][i].carrera_name} - ${cupos(data[0][i].cupos)}`
            })
        }

        respuesta(contenido)
    });
}

export const addRequisito = (texto, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            texto: texto
        }

        Post(`${Url}addRequisito`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const consultaRequisitos = (respuesta) => {
    Post(`${Url}searchRequisito`, "", (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0])
    });
}

export const editRequisito  = (id, texto, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            texto: texto
        }

        Post(`${Url}editRequisito`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const delRequisito = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
        }

        Post(`${Url}delRequisito`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const datosSelect = (respuesta) => {
    consultaUser((usuario) => {
        let Content = {
            usuario: usuario
        }

        Post(`${Url}consultRequisitos`, Content, (resp) => {
            let data = JSON.parse(resp);
            let mes = (num) => {
                let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMPBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]
                return meses[num - 1]
            }

            let periodo = {
                value: data[1].pediodo,
                label:`${mes(data[1].corte_name)} - ${data[1].corte_year}`
            }

            let cupos = (cupos) => {
                let letra = "";
                if (cupos > 1) letra = "S";
                return `[${cupos} CUPO${letra}]`
            }

            let carrera = { value: '', label: ' - Selecciona una Carrera - ' }

            if (data[2].length > 0) carrera = {
                value: data[2][0].carrera,
                /* label: `${data[2][0].carrera_name} - ${cupos(data[2][0].cupos)}`, */
                label: data[2][0].carrera_name,
                label2: data[2][0].carrera_name
            }

            let status = data[1].status
            let token = data[1].token

            respuesta([data[0], periodo, carrera, status, data[3], token, data[1].fecha_solicitud, data[1].fecha_cita])
        });
    });
}

export const ConsultIntervalo = (respuesta) => {
    Post(`${Url}consultIntervalo`, "", (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0])
    });
}

export const ChkAdmisiones = (respuesta) => {
    Post(`${Url}chkAdmisiones`, "", () => {
        respuesta("Ok")
    });
}

export const SvgToPng = (svgData, respuesta) => {
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    canvas.width = 200;
    canvas.height = 200;

    let image = new Image();

	image.onload = () => { 
        context.clearRect(0, 0, 200, 200);
        context.drawImage(image, 0, 0, 200, 200);
        let pngData = canvas.toDataURL('image/png');
        respuesta(pngData)
    };

    image.src = svgData;
}

export const ConsultCitadosReinsc = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}ConsultCitadosReinsc`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultAllCitadosReinsc = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}ConsultAllCitadosReinsc`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultDetallesReinsc = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est
        }

        Post(`${Url}ConsultDetallesReinsc`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta([data[0], data[1], data[2], data[3], data[4]])
        });
    });
}

export const ConsultCitados = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultcitados`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const BusquedaEstAdm = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string
        }

        Post(`${Url}BusquedaEstAdm`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const BusquedaEstReins = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string
        }

        Post(`${Url}BusquedaEstReins`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const ConsultAllCitados = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultAllcitados`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultDetalles = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}consultcitadoDetalle`, Content, (resp) => {
            let data = JSON.parse(resp);
            let Contenido = {
                datos: data[0],
                parriquia: data[1],
                parriquiaDir: data[2],
                municipio: data[3],
                municipioDir: data[4],
                estado: data[5],
                pais: data[6],
            }

            respuesta([Contenido, data[7]])
        });
    });
}

export const NoAdmitir = (id, motivo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            Id: id,
            Motivo: motivo
        }

        Post(`${Url}noAdmitido`, Content, (resp) => {
            respuesta(resp);
        });
    });
}

export const NoInscribir = (id, motivo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            Id: id,
            Motivo: motivo
        }

        Post(`${Url}NoInscribir`, Content, (resp) => {
            respuesta(resp);
        });
    });
}

export const Admitir = (id, observaciones, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            Id: id,
            Observaciones: observaciones,
        }
        Post(`${Url}admitido`, Content, (resp) => {
            respuesta(resp);
        });
    });
}

export const CambiaFechaAdm = (id, fecha, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            Id: id,
            fecha: fecha
        }

        Post(`${Url}CambiaFechaAdm`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data);
        });
    });
}

export const InscribirAdmin = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            Id: id
        }

        Post(`${Url}InscribirAdmin`, Content, (resp) => {
            respuesta(resp);
        });
    });
}

export const copyFile = (file, nombre, respuesta) => {
    let Content = {
        nombre: nombre
    }

    PostArchivo(`${Url}copyFile`, file, "", Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data)
    });
}

export const ListAdmisionE = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            carreraId: id
        }

        Post(`${Url}ListAdmisionE`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const ListInscritos = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            carreraId: id
        }

        Post(`${Url}ListInscritos`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/AdmisionFunction.jsx